import axios from "axios";
import type { AxiosRequestConfig } from "axios";
import { apiClient } from "./axios";

export interface ApiResult<T = unknown> {
  ok: boolean;
  status: number;
  data?: T;
  message?: string;
  error?: string;
  success?: boolean;
}

export const requestJson = async <T = unknown>(
  url: string,
  init?: AxiosRequestConfig
): Promise<ApiResult<T>> => {
  try {
    const response = await apiClient.request<T>({
      url,
      ...init,
    });

    const resData = response.data as Record<string, unknown>;
    const hasDataField = resData && typeof resData === "object" && "data" in resData;

    return {
      ok: true,
      success: true,
      status: response.status,
      data: hasDataField ? (resData.data as T) : response.data,
      message: resData?.message as string | undefined,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const resData = error.response?.data as Record<string, unknown> | undefined;
      const hasDataField = resData && typeof resData === "object" && "data" in resData;
      const message = (resData?.message as string) || error.message || "Không thể kết nối máy chủ";

      return {
        ok: false,
        success: false,
        status: error.response?.status ?? 0,
        error: message,
        message: message,
        data: hasDataField ? (resData.data as T) : (resData as T),
      };
    }

    return {
      ok: false,
      success: false,
      status: 0,
      error: error instanceof Error ? error.message : "Không thể kết nối máy chủ",
    };
  }
};
